<template>
  <svg width="598" height="284" viewBox="0 0 598 284" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65 253.696C65 253.696 186.294 244.66 208.662 142.879C231.03 41.0981 298.367 47.786 298.367 47.786C298.367 47.786 379.304 44.4091 394.315 142.879C409.325 241.35 533 253.696 533 253.696" stroke="#347AF6" stroke-width="4" stroke-linecap="round" />
    <path d="M299 253.696V58.6958" stroke="#FE4572" stroke-width="2" stroke-dasharray="8 4" />
    <path d="M9.56097 2V275.5H596.5M9.56097 2L1.5 9.5M9.56097 2L16.6143 9.5M596.5 275.5L588.439 267.5M596.5 275.5L588.439 283" stroke="#555555" stroke-width="2" />
  </svg>
</template>

<script>
export default {
  name: 'StartTeachingSvgCode'
}
</script>

<style scoped>

</style>
